import { sortDateDesc } from '@strata/helper-functions';
import { FullscreenLoading } from '@strata/react-fullscreen-loading';
import { MessagingBlock } from '@strata/react-messaging-block';
import { PageTitle } from '@strata/react-page-title';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { Formik } from 'formik';
import { useState } from 'react';

import { formatInboundOrtfSourceLabel } from './formatInboundOrtfSourceLabel';
import { OrtfInboundFileOverviewContent } from './OrtfInboundFileOverviewContent';

import { useGetInboundFileOverviewQuery, useGetInboundFilesQuery } from 'store/api/ndpApi';

export const OrtfInboundOverviewTab = () => {
    const [selectedInboundOrtfId, setSelectedInboundOrtfId] = useState('');

    const { data: inboundFiles = [], isFetching: isFetchingFiles } = useGetInboundFilesQuery();
    const { data: overview, isFetching: isFetchingOverview } = useGetInboundFileOverviewQuery(
        selectedInboundOrtfId,
        { skip: !selectedInboundOrtfId },
    );

    const fileOptions = [...inboundFiles]
        .sort((a, b) => sortDateDesc(a.dateReceived, b.dateReceived))
        .map(({ inboundOrtfId, sendingPharmacyName, dateReceived }) => ({
            value: inboundOrtfId,
            name: formatInboundOrtfSourceLabel(sendingPharmacyName, dateReceived) ?? inboundOrtfId,
        }));

    const selectedItem = fileOptions.find(({ value }) => value === selectedInboundOrtfId);
    const showOverview = !!selectedInboundOrtfId && !!overview && !isFetchingOverview;

    return (
        <div className="margin__top--medium">
            <PageTitle title="Inbound History" />
            <FullscreenLoading
                isShowing={isFetchingFiles || isFetchingOverview}
                loadingText="Loading..."
            />
            <Formik
                initialValues={{ inboundOrtfId: selectedInboundOrtfId }}
                enableReinitialize
                onSubmit={() => undefined}
            >
                {(formik) => (
                    <div style={{ maxWidth: '450px' }}>
                        <SuggestSingleSelectFormik
                            id="inboundOrtfId"
                            label="Inbound File"
                            isLoading={isFetchingFiles}
                            values={fileOptions}
                            selectedItem={selectedItem}
                            onChange={(newValue) => {
                                const nextId = newValue?.value ?? '';
                                formik.setFieldValue('inboundOrtfId', nextId);
                                setSelectedInboundOrtfId(nextId);
                            }}
                        />
                    </div>
                )}
            </Formik>

            {!selectedInboundOrtfId ? (
                <MessagingBlock
                    className="margin__top--large"
                    size={MessagingBlock.Sizes.MEDIUM}
                    secondaryText="Select an inbound file to view its overview."
                />
            ) : null}

            {showOverview ? (
                <OrtfInboundFileOverviewContent largeTotal overview={overview} />
            ) : null}
        </div>
    );
};
